import { useQuery } from '@apollo/client';

import { getLatestTranscriptQuery } from './operations';

export type AppointmentTranscriptQueryArgs = {
  tenantId: string;
  appointmentId: string;
};

/**
 * Reads the consolidated transcript for an explicit appointment. Unlike the
 * in-session transcription sync, this can load evidence from an earlier visit.
 */
export const useAppointmentTranscriptQuery = ({
  tenantId,
  appointmentId,
}: AppointmentTranscriptQueryArgs) => {
  const { data, loading, error } = useQuery(getLatestTranscriptQuery, {
    variables: { tenantId, appointmentId },
    fetchPolicy: 'cache-first',
  });

  return {
    loading,
    error,
    transcript: data?.appointmentsByPk?.transcription?.transcript ?? '',
    startDate: data?.appointmentsByPk?.startDate ?? null,
  };
};
